export default "<h2>Customer List</h2>\n<app-client-list>Loading ...</app-client-list>\n"